<template>
  <SettingsPaneV2 header="Storage">
    <template #subheader>View and configure storage for your team.</template>
    <template #header-action>
      <StorageCreation />
    </template>

    <template #body>
      <div class="body__section banner">
        <div class="text-container">
          <p class="control__toggle-label">Learn more about storage</p>
          <p class="control__toggle-sub-label">
            A guide on annotating files in your cloud storage with V7
          </p>

          <DarwinButton
            class="text-container--button"
            size="md"
            kind="secondary"
            flair="rounded"
            to="https://docs.v7labs.com/docs/external-storage-configuration"
            target="_blank"
          >
            Read documentation
          </DarwinButton>
        </div>
        <div class="image-container">
          <div class="storage-image" />
          <div class="storage-gradient-image" />
        </div>
      </div>

      <div class="storage__content">
        <Spinner
          v-if="loading"
          class="storage__spinner"
          size="md"
          color="dark"
          label="Storage"
        />
        <StoragesList v-else />
      </div>
    </template>
  </SettingsPaneV2>
</template>

<script lang="ts">
export default {
  name: 'LayoutSettingsStorage',
}
</script>

<script lang="ts" setup>
import { ref, watch } from 'vue'

import StorageCreation from '@/components/Storage/StorageCreation.vue'
import StoragesList from '@/components/Storage/StoragesList.vue'
import DarwinButton from '@/uiKit/Button/DarwinButton.vue'
import { getStorages } from '@/backend/darwin/getStorages'

import { useTeamStore } from '@/pinia/useTeamStore'
import Spinner from '@/uiKit/Spinner/Spinner.vue'

import SettingsPaneV2 from './SettingsPaneV2.vue'
import { useExternalStorageStore } from '@/modules/ExternalStorage/useExternalStorageStore'

const loading = ref(false)

const teamStore = useTeamStore()
const storageStore = useExternalStorageStore()

watch(
  () => teamStore.currentTeam,
  async () => {
    if (!teamStore.currentTeam) {
      return
    }
    loading.value = true

    const result = await getStorages({ teamSlug: teamStore.currentTeam.slug })
    if (result.ok) {
      storageStore.storages = result.data
    }

    loading.value = false
  },
  { immediate: true },
)
</script>

<style lang="scss" scoped>
.storage__content {
  position: relative;
}
.storage__spinner {
  position: absolute;
  top: 50px;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.body__section {
  margin-bottom: 16px;
}

.control__toggle-label,
.control__toggle-sub-label {
  @include typographyRegularBody200;
  color: var(--color-text-default);
  margin-left: 8px;
}
.control__toggle-sub-label {
  color: var(--color-text-subtlest);
}
.banner {
  @include row;
  align-items: center;
  background-color: var(--color-surface-secondary);
  border-radius: 16px;
}
.text-container {
  padding: 20px;

  & .control__toggle-label {
    @include typographyBoldBody300;
  }
}
.text-container--button {
  margin-top: 25px;
}

.image-container {
  position: relative;
  flex: 1;
}
.storage-image {
  background-image: url('./assets/storage.svg');
  background-repeat: no-repeat;
  height: 164px;
  width: 298px;
}
.storage-gradient-image {
  position: absolute;
  top: 0;
  right: 0;
  background-image: url('./assets/gradient.svg');
  height: 164px;
  width: 296px;
  border-radius: 16px;
}
</style>
